import { Badge } from '@libs/ui/ds'
import { usePlanningTranslation } from '@libs/utils/translations'
import type { FC } from 'react'
import React from 'react'

import { isDayBeforeDST } from './utils/isDayBeforeDST'

type Props = {
  date: string
  className?: string
}

const DaylightSavingTimeBadge: FC<Props> = ({ date, className = '' }) => {
  const { t } = usePlanningTranslation()
  const isDayBeforeDSTChange = isDayBeforeDST(date)

  if (!isDayBeforeDSTChange) {
    return null
  }

  return (
    <div className={className}>
      <Badge
        color='semantic.blue'
        label={t('common.daylightSavingTimeChange')}
        size='xs'
      />
    </div>
  )
}

export default DaylightSavingTimeBadge
